var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.932 5.555L0 6.624 5.277 12 14 .917 11.934 0 5.056 8.738z","fill":"currentColor","fillRule":"nonzero"}));
}

CheckmarkInline.defaultProps = {"width":"14","height":"12"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
